import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import * as fromExemptions from '../reducers/tax-exemptions.reducer';

export const getExemptionsState = createSelector(fromFeature.getShopifyState, (state: fromFeature.ShopifyState) => state.exemptions);

export const getExemptionResult = createSelector(getExemptionsState, fromExemptions.getExemptionResult);
export const getExemptionValid = createSelector(getExemptionsState, fromExemptions.getExemptionValid);
export const getExemptionChecking = createSelector(getExemptionsState, fromExemptions.getExemptionChecking);
export const getExemptionChecked = createSelector(getExemptionsState, fromExemptions.getExemptionChecked);
export const getExemptionErrors = createSelector(getExemptionsState, fromExemptions.getExemptionErrors);
